import React from 'react';
import {useSelector} from 'react-redux';

import AemEditableText from '@/components/Aem/AemEditableText/AemEditableText';
import {AppButton} from '@/components/Button';
import {OtherDeviceConnectedIcon} from '@/components/Icons';
import * as localizationKeys from '@/consts/localization/localizationKeys';
import routePaths from '@/consts/route/routePaths';
import useOnConnectClick from '@/containers/DevicesPage/hooks/useOnConnectClick';
import useIsMobileLayout from '@/hooks/layout/useIsMobileLayout';
import {getAriaLabel} from '@/services/accessibilityService';
import amplitudeDeviceTracking from '@/services/analytics/amplitude/amplitudeDeviceTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {selectCurrentProductInfo} from '@/state/selectors/device';

import DevicesSettingsSection from '../../../DevicesSettingsSection/DevicesSettingsSection';

const MyDevicesConnectButton = () => {
    const isMobile = useIsMobileLayout();

    const device = useSelector(selectCurrentProductInfo);
    const {deviceSerialNumber, type} = device || {};
    const handleOnConnectClick = useOnConnectClick(type, deviceSerialNumber);

    const onConnectClick = () => {
        amplitudeDeviceTracking.trackPairDeviceClick(deviceSerialNumber, type);
        googleAnalyticsService.trackPairDeviceClick(type, deviceSerialNumber);
        handleOnConnectClick();
    };

    return isMobile ? (
        <MobileConnectButton onClick={onConnectClick} />
    ) : (
        <DesktopConnectButton onClick={onConnectClick} />
    );
};

const MobileConnectButton = ({onClick}) => {
    return (
        <DevicesSettingsSection.Button
            textClassName='ml:font-bold'
            itemName='connectYourIqosNew'
            icon={OtherDeviceConnectedIcon}
            onClick={onClick}
            ariaLabelKey={localizationKeys.MY_DEVICES_PAGE_CONNECT_DEVICE_BUTTON_ARIA_LABEL}
        />
    );
};

const DesktopConnectButton = ({onClick}) => {
    return (
        <AemEditableText
            pageName={routePaths.DEVICES_PAGE}
            itemName='connectButton'
            render={(text) =>
                text && (
                    <AppButton
                        className='m-0 mt-4 shrink-0 self-start'
                        primary
                        light
                        onClick={onClick}
                        aria-label={getAriaLabel(localizationKeys.MY_DEVICES_PAGE_CONNECT_DEVICE_BUTTON_ARIA_LABEL)}
                    >
                        {text}
                    </AppButton>
                )
            }
        />
    );
};

export default MyDevicesConnectButton;
